import { PlatformSlug } from 'constants/consts'
import { enabledOn, isFeatureAvailable } from 'platformConfig'

export const CHAPTER_NOTES_CONFIG = enabledOn(PlatformSlug.CasperBooster)

export const isChapterNotesAvailable = (slug?: PlatformSlug) => isFeatureAvailable(CHAPTER_NOTES_CONFIG, slug)
